<template>
    <div id="app">
        <router-view />
    </div>
</template>
<script setup>
import * as echarts from "echarts";
import { onMounted, provide, ref } from "vue";
import store from "./store";
import { getPlatformConfig, getLoginMethod } from '@/api/configInfo';

const webPlatformConfig = ref({
    webPlatformLogo: '',
    webPlatformName: '',
});
provide("webPlatformConfig", webPlatformConfig);
provide("echarts", echarts);

function applyPlatformConfig(response) {
    if (response.code !== 200 || !response.data || !response.data.sysLogoConfigWebDTO) {
        return;
    }
    const currentIcon = response.data.sysLogoConfigWebDTO.webFavoriteIcon;
    if (currentIcon) {
        const link = document.querySelector('link[rel*="icon"]');
        if (link) {
            link.href = currentIcon;
        }
    }
    const currentTitle = response.data.sysLogoConfigWebDTO.webPlatformName;
    if (currentTitle) {
        webPlatformConfig.value.webPlatformName = currentTitle;
        document.title = currentTitle;
    }
    if (response.data.sysLogoConfigWebDTO.webPlatformLogo) {
        webPlatformConfig.value.webPlatformLogo = response.data.sysLogoConfigWebDTO.webPlatformLogo;
    }
}

function init() {
    const local = location.host;
    // const local = 'www.les-ponts.com';
    // const local = 'web.planet-alpha.net';
    // const local = 'web.int.cryun.com';
    // store.dispatch('setIsLesPonts', local.includes('les-ponts'));

    // if(store.getters.isLesPonts) {

    // }

    if (local.includes('les-ponts')) {
        store.dispatch('setHostName', 'les-ponts');
    } else if (local.includes('cryun.com')) {
        store.dispatch('setHostName', 'ctw');
    } else if (local.includes('zhangkenan.com')) {
        store.dispatch('setHostName', 'ctw');
    } else {
        store.dispatch('setHostName', 'planet-alpha');
    }

    getLoginMethod().then(res => {
        const needPlatformId = res?.code === 200 && String(res?.data?.loginMethod || '').includes('2');
        const platformParams = needPlatformId ? { loginPlatFormId: res?.data?.platForm || 1 } : {};
        return getPlatformConfig(platformParams);
    }).then(response => {
        applyPlatformConfig(response);
    }).catch((err) => {
        console.log(err);
    });
}

onMounted(() => {
    init();
})
</script>
<style lang="scss">
html,
body,
#app {
    width: 100%;
    height: 100%;
}

@import "./assets/css/reset.scss";
</style>
